export enum MaritalStatus {
  /**
   * Single
   */
  Single = 'single',

  /**
   * Married
   */
  Married = 'married',

  /**
   * Civil union
   */
  CivilUnion = 'civil-union',

  /**
   * Divorced
   */
  Divorced = 'divorced',

  /**
   * Widowed
   */
  Widowed = 'widowed',

  /**
   * Other
   */
  Other = 'other',
}
